export enum ServiceGrouping {
  Location = 'Location',
  Service = 'Service',
  Status = 'Status',
}
